import {    TwitterShareButton, TwitterIcon, } from 'react-share';
const Twitter = ({ url, quotes, hashtag }) => {
    return (
        <>

            <TwitterShareButton
                url={url}   
                quotes={quotes}  
            >
                <TwitterIcon  style={{width: "40px", height: "40px"}}/>
            </TwitterShareButton>

        </>
    )
}

export default Twitter;